"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetCampaigns($filter: CampaignFilter, $limit: Int, $offset: Int, $organisationId: String!) {\n    getCampaigns(filter: $filter, limit: $limit, offset: $offset, organisationId: $organisationId) {\n      count\n      campaigns {\n        inspirationCampaignId\n        name\n        coverImageKey\n        startDate\n        description\n        endDate\n        index\n        isActive\n        organisationId\n        updatedAt\n        updatedByUser {\n          firstName\n          lastName\n          imageUrl\n          jobTitle\n        }\n        permissions\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getCampaignsQuery = (0, _graphqlTag.default)(_templateObject());

var getCampaigns = function getCampaigns(organisationId) {
  return {
    query: getCampaignsQuery,
    module: 'inspirations',
    ignoreCache: true,
    buildVariables: function buildVariables(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          filter = _objectWithoutProperties(_ref, ["limit", "offset"]);

      return {
        filter: filter,
        limit: limit,
        offset: offset,
        organisationId: organisationId
      };
    }
  };
};

var _default = getCampaigns;
exports.default = _default;